<template>
  <div v-if="geographic" id="cursor-location">
    <x-metadata-text>
      {{ formatString() }}
    </x-metadata-text>
  </div>
</template>

<!-- eslint-disable vue/block-lang -->
<script>
/* eslint-disable vue/component-api-style */
import { DDM, DECIMAL, DMS, UTM } from '@/lib/geographic'
import { cursorCoord } from '@/services/map-service'
import xMetadataText from '@/components/shared/x-metadata-text'

const formatDecimal = (geographic, isSecretSpotMode) => {
  if (isSecretSpotMode) {
    return '00.000, 00.000'
  }

  return geographic.toDegreesString()
}

const formatDms = (geographic, isSecretSpotMode) => {
  if (isSecretSpotMode) {
    return `0° 00' 00.00" 0° 00' 00.00"`
  }

  return geographic.toDmsString()
}

const formatDdm = (geographic, isSecretSpotMode) => {
  if (isSecretSpotMode) {
    return `0° 00.00', 0° 00.00'`
  }

  return geographic.toDdmString()
}

const formatUtm = (geographic, isSecretSpotMode) => {
  if (isSecretSpotMode) {
    return '00T 00 m 00 m'
  }

  return geographic.toUtmString()
}

export default {
  name: 'ControlCursorLocation',

  components: {
    xMetadataText,
  },

  data: () => ({
    geographic: null,
  }),

  computed: {
    coordinateType() {
      return this.$storage.getItem('coordinateType') || DECIMAL
    },

    isSecretSpotMode() {
      return this.$storage.getItem('secretSpotToggle') || false
    },

    cursorCoord,
  },

  watch: {
    cursorCoord(geoPoint) {
      this.geographic = geoPoint
    },
  },

  methods: {
    formatString() {
      return {
        [DECIMAL]: formatDecimal,
        [DMS]: formatDms,
        [DDM]: formatDdm,
        [UTM]: formatUtm,
      }[this.coordinateType](this.geographic, this.isSecretSpotMode)
    },
  },
}
</script>

<style lang="scss" scoped>
@use '@/styles/system/_colors.scss';

#cursor-location {
  background-color: colors.$Grey30;
  color: colors.$Grey80;
  padding: 2px 13px;
  opacity: 0.84;
  display: inline-block;
  vertical-align: bottom;
}

@media print {
  #cursor-location {
    display: none;
  }
}
</style>
